<template>
      <div no-body class="lku-jenisiklan"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <!-- <b-form-group horizontal label="Filter" label-cols="1" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="jenisiklan_search" placeholder="Jenis Iklan" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-form-input v-model="uraian_search" placeholder="Description" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group> -->
        <b-input-group >
          <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
          <b-form-radio-group class="mt-2" v-model="tblData.groupiklan" >
            <b-form-radio value=0 selected>Display/Umum</b-form-radio>
            <b-form-radio value=1>Class Ad./Koloman</b-form-radio>
            <b-form-radio value=2>Baris</b-form-radio>
          </b-form-radio-group>
        </b-input-group>

        </b-col>
      </b-row>

        <b-table
          class="mb-0"
          ref="tblJenisIklan"
          responsive
          striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(index)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
          </template>
          <template v-slot:cell(classad)="data">
            <span v-if="(data.item.classad)">KOLOM/CLASS AD</span>
            <span v-else>IKLAN UMUM</span>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>
<style lang="scss">
  .lku-jenisiklan {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import accounting from 'accounting-js'

export default {
  props: ['classad'],
  data() {
    return {
      jenisiklan_search:'',
      uraian_search:'',
      fields: [
          { key: "jenisiklan" , 
            label: "Jenis Iklan ",
            sortable: true
          },
          {
            key: "classad",
            label: "Group",
          },
          {
            key: "hargabw",
            label: "Harga B/W",
            formatter: "numberFormat",
            tdClass: "text-right pr-1"
          },
          {
            key: "hargafc",
            label: "Harga Full Color",
            formatter: "numberFormat",
            tdClass: "text-right pr-1"
          },
          {
            key: "uraian",
            label: "Description",
          }
      ],
      tblData: {
        tablename:'jenisiklankoran',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'jenisiklan',
        sortDesc: false,
        groupiklan:'0'
      },
      lkuLoading:false
    };
  },
  computed: {
    groupiklan() {
      return this.tblData.groupiklan;
    },
    
  },
  watch: {
    groupiklan: function (newval)
    {
      // setTimeout(() => {
        this.refresh();        
      // }, 100);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    numberFormat(val) {
      // console.log('val', val);
      // console.log('accounting.formatNumber(val ,0): ', accounting.formatNumber(val,0));
      return `${accounting.formatNumber(val)}`
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      if (this.classad || this.tblData.groupiklan){
          this.tblData.customQuery = `classad=${this.classad || this.tblData.groupiklan}`;
      }
      console.log(this.tblData);

      // if(this.jenisiklan_search && this.jenisiklan_search.trim().length > 0){
      //   this.tblData.customQuery = this.tblData.customQuery + `&&jenisiklan=%${this.jenisiklan_search}%`;
      // }
      // if(this.uraian_search && this.uraian_search.trim().length > 0){
      //   this.tblData.customQuery = this.tblData.customQuery + `&&uraian=%${this.uraian_search}%`;
      // }
      // console.log('this.tblData:', this.tblData);
      const list = await crud.list(this.tblData);     
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={jenisiklan:'', uraian: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblJenisIklan.refresh();
       }
    },    
    refresh() {
      this.$refs.tblJenisIklan.refresh();
    }
  }
};
</script>
